import { ApplicantStage } from './applicants'

export enum TriggerDelayType {
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}

export enum Frequency {
  ONCE = 'ONCE',
  MINUTE = 'MINUTE',
  HOURLY = 'HOURLY',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  BIANNUALLY = 'BIANNUALLY',
  YEARLY = 'YEARLY',
}

export enum AutomatedRuleActionType {
  SMS = 'SMS',
  SEND_EMAIL = 'SEND_EMAIL',
  DOCUMENT_TEMPLATE_PACKAGE = 'DOCUMENT_TEMPLATE_PACKAGE',
  GENERATE_ORDER = 'GENERATE_ORDER',
  ASSIGN_TRAINING = 'ASSIGN_TRAINING',
  ASSIGN_COURSE = 'ASSIGN_COURSE',
  SEND_TRAINING_REMINDER = 'SEND_TRAINING_REMINDER',
  SEND_VOICE_AGENT_CALL = 'SEND_VOICE_AGENT_CALL',
  CHANGE_APPLICANT_STATUS = 'CHANGE_APPLICANT_STATUS',
  CREATE_TASK = 'CREATE_TASK',
  START_VOE_OUTREACH = 'START_VOE_OUTREACH',
  REASSIGN_LEAD_EMPLOYEE = 'REASSIGN_LEAD_EMPLOYEE',
  ADD_MEMBER_EMPLOYEE = 'ADD_MEMBER_EMPLOYEE',
  ADD_NOTE = 'ADD_NOTE',
}

export enum AutomatedRuleStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum AutomatedRuleConditionKey {
  applicantStage = 'applicantStage',
  callCount = 'callCount',
  missedOutboundCallCount = 'missedOutboundCallCount',
  jobListingId = 'jobListingId',
  jobListingType = 'jobListingType',
  linkType = 'linkType',
  hiringStage = 'hiringStage',
  notInterestedReason = 'notInterestedReason',
  disqualifiedReason = 'disqualifiedReason',
  terminatedReason = 'terminatedReason',
  eligibleForRehire = 'eligibleForRehire',
  isPermanentlyDisqualified = 'isPermanentlyDisqualified',
  // Applicant has ANY of the selected company tags; value = CompanyTag.tagId.
  tagId = 'tagId',
  recruiterId = 'recruiterId',
}

export const mapApplicantStageToConditionKey = (
  applicantStage: ApplicantStage
): AutomatedRuleConditionKey | null => {
  switch (applicantStage) {
    case ApplicantStage.PROSPECT:
      return AutomatedRuleConditionKey.hiringStage
    case ApplicantStage.DISQUALIFIED:
      return AutomatedRuleConditionKey.disqualifiedReason
    case ApplicantStage.NOT_INTERESTED:
      return AutomatedRuleConditionKey.notInterestedReason
    case ApplicantStage.TERMINATED:
      return AutomatedRuleConditionKey.terminatedReason
    default:
      // If the applicant stage is HIRED, return null
      return null
  }
}
